import { Injectable } from '@angular/core';
@Injectable()
export class ExportService {
  Export(exportData: any, fileName: string): void {
    if (exportData != null && exportData != undefined) {
      let blob = new Blob([exportData], { type: 'octet/stream' });
      const nav = (window.navigator as any);
      if (nav.msSaveOrOpenBlob) {
        nav.msSaveOrOpenBlob(blob, fileName);
      } else {
        const a = document.createElement('a');
        document.body.appendChild(a);
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        }, 0)
      }
    }
  }
}
